import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '../../assets/svgs/CloseIcon';
import { colors, functions } from '../../ui/variables';

import { ModalStyle } from './ModalStyle';

const Modal = ({
  children,
  fullScreen,
  handleClose,
  overlay,
  theme,
  withShadow,
}) => {
  const classNames = useMemo(() => {
    const current = [theme && theme.length ? `${theme}-theme` : 'light-theme'];

    if (withShadow) {
      current.push('with-shadow');
    }

    if (fullScreen) {
      current.push('fullscreen');
    }

    return current;
  }, [fullScreen, theme, withShadow]);

  return (
    <ModalStyle className={classNames} style={{ backgroundColor: overlay }}>
      <div className="modal-box">
        {handleClose ? (
          <div className="close-modal-wrapper">
            <button
              className="close-modal"
              type="button"
              onClick={handleClose}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>
        ) : null}
        <div className="modal-content-wrapper">{children}</div>
      </div>
    </ModalStyle>
  );
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  fullScreen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  overlay: PropTypes.string,
  theme: PropTypes.string,
  withShadow: PropTypes.bool,
};

Modal.defaultProps = {
  fullScreen: false,
  overlay: functions.rgba(colors.black, 0.5),
  theme: 'light',
  withShadow: false,
};

export default Modal;
